import { Entity } from '../entity.js';
import { clampPointToward, isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

function pushSkillshot(bucket, caster, tx, ty, gameTime, opts) {
  const angle = Math.atan2(ty - caster.y, tx - caster.x);
  bucket.push({
    id: `${opts.idPrefix}-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * opts.speed,
    vy: Math.sin(angle) * opts.speed,
    range: opts.range,
    traveled: 0,
    damage: opts.damage,
    damageType: opts.damageType || 'physical',
    radius: opts.radius || 16
  });
}

export function createZed(id = 'zed-1', team = 'blue', x = 300, y = 1300) {
  return new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 584,
    maxMp: 200,
    ad: 65,
    ap: 0,
    armor: 32,
    mr: 32,
    ms: 345,
    attackRange: 125,
    attackSpeed: 0.651,
    name: 'Zed',
    radius: 20
  });
}

export function castZedQ(caster, tx, ty, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 75) return false;
  caster.mp -= 75;
  pushSkillshot(projectiles, caster, tx, ty, gameTime, {
    idPrefix: 'zed-q',
    speed: 1700,
    range: 925,
    damage: 70 + (caster.ad || 0) * 1.0,
    radius: 50
  });
  return true;
}

export function castZedW(caster, tx, ty) {
  if (!caster || caster.isDead) return false;
  if (caster.zedShadow) {
    const sx = caster.zedShadow.x;
    const sy = caster.zedShadow.y;
    caster.zedShadow = { x: caster.x, y: caster.y, remainingSec: caster.zedShadow.remainingSec };
    caster.x = sx;
    caster.y = sy;
    return true;
  }
  if (caster.mp < 40) return false;
  caster.mp -= 40;
  const pos = clampPointToward(caster.x, caster.y, tx, ty, 650, caster);
  caster.zedShadow = {
    x: pos.x,
    y: pos.y,
    remainingSec: 5.25
  };
  return true;
}

export function castZedE(caster, entities) {
  if (!caster || caster.isDead || caster.mp < 40) return false;
  caster.mp -= 40;
  for (const e of entities || []) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, caster.x, caster.y, 315, caster)) continue;
    e.takeDamage(65 + (caster.ad || 0) * 0.8, caster, 'physical');
  }
  return true;
}

export function castZedR(caster, target) {
  if (!caster || caster.isDead || !target || target.isDead) return false;
  if (!isWithinAbilityRange(caster, target, 625, caster)) return false;
  target.takeDamage(100 + (caster.ad || 0) * 1.0, caster, 'physical');
  return true;
}
